import "./styles.css";

import { createRoot } from "react-dom/client";
import { Info } from "./info";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById("root")!);
root.render(<Info />);
